/**
 * Mock customer notes for dev / mock-mode. Linked to seeded mock customers
 * (`cust-001`..`cust-003`) so the customer Notes tab has data.
 */

import type { CustomerNote } from '@/types/note.types'

export const mockNotes: CustomerNote[] = [
  {
    id: 'note-001',
    customerId: 'cust-001',
    body: 'Client prefers WhatsApp for document requests. Responds quickly in the evenings.',
    authorName: 'Priya Sharma',
    createdAt: '2025-06-02T10:30:00Z',
  },
  {
    id: 'note-002',
    customerId: 'cust-001',
    body: 'Has a new house property this year — will need rental income details for the filing.',
    authorName: 'Rajesh Kumar',
    createdAt: '2025-06-05T15:10:00Z',
  },
  {
    id: 'note-003',
    customerId: 'cust-002',
    body: 'Sold equity in March; confirm whether STT was paid for LTCG treatment.',
    authorName: 'Amit Patel',
    createdAt: '2025-06-06T09:45:00Z',
  },
  {
    id: 'note-004',
    customerId: 'cust-003',
    body: 'First-time client referred by an existing customer. Walk through the process slowly.',
    authorName: 'Neha Gupta',
    createdAt: '2025-06-07T13:20:00Z',
  },
]
